
import { supabase } from "@/integrations/supabase/client";
import { ArticleMediaItem } from "./types";

export const articleMediaService = {
  async processArticleMedia(articleId: string, blocks: any[], authorId: string) {
    try {
      // Find all image blocks
      const mediaBlocks = blocks.filter(block => 
        block.type === 'image' && block.data && block.data.file && block.data.file.filePath);
      
      if (mediaBlocks.length === 0) return;
      
      // Create entries in the article_media table
      const mediaEntries = mediaBlocks.map(block => {
        const filePath = block.data.file.filePath;
        const fileName = filePath.split('/').pop();
        
        return {
          article_id: articleId,
          storage_path: filePath,
          media_type: 'image',
          file_name: fileName,
          file_size: block.data.file.size || 0,
          mime_type: block.data.file.mime || 'image/jpeg',
          alt_text: block.data.caption || '',
          caption: block.data.caption || '',
          width: block.data.file.width || null,
          height: block.data.file.height || null,
          uploaded_by: authorId
        } as ArticleMediaItem;
      });
      
      // Process each media entry individually to avoid issues with upsert
      for (const entry of mediaEntries) {
        // Check if entry already exists
        const { data: existingMedia } = await supabase
          .from('article_media')
          .select('*')
          .eq('article_id', entry.article_id)
          .eq('storage_path', entry.storage_path)
          .maybeSingle();
        
        if (existingMedia) {
          // Update existing entry
          const { error: updateError } = await supabase
            .from('article_media')
            .update(entry)
            .eq('article_id', entry.article_id)
            .eq('storage_path', entry.storage_path);
          
          if (updateError) {
            console.error('Error updating article media:', updateError);
          }
        } else {
          // Insert new entry
          const { error: insertError } = await supabase
            .from('article_media')
            .insert(entry);
          
          if (insertError) {
            console.error('Error inserting article media:', insertError);
          }
        }
      }
    } catch (error) {
      console.error('Error processing article media:', error);
    }
  }
};
